import React from "react";

import { Card, Col, Row } from "react-bootstrap";

import HeroSection from "../../utilities/HeroSection.jsx";
import "./assets/css/history.css";

import image2 from "./assets/images/history-3.png";
import image3 from "./assets/images/history-4.png";
import image5 from "./assets/images/history-5.png";

function History({ banners, isLoading, error }) {
  const historyBanners = banners ? banners["who we are - our history"] : [];
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HeroSection
        banners={historyBanners}
        isLoading={isLoading}
        error={error}
      />
      <Card className="text-start p-md-3 border-0">
        <Card.Body
          style={{ maxWidth: 1120 + `px`, margin: 0 + ` auto`, fontSize: 20 }}
        >
          <Card.Title className="text-maroon my-4 font-header text-left">
            Paulines Family
          </Card.Title>
          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            Under the loving insistence of Blessed James Alberione, the
            Congregation of the Daughters of St Paul was born in June 1915 in
            Alba, Italy, without a name, without anyone's notice, nor even a
            house to call their own. It all started with a group of young women
            who opened their “first press” by sewing shirts for the military
            during the very difficult years of the First World War.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            When the First World War ended, the young women abandoned sewing
            shirts and took on the apostolate of the printing press. Their first
            assignment was in Susa, a little village where they took charge of
            printing the Diocesan Newspaper, “La Valsusa”. This was a major
            breakthrough for these women, and an opportunity which boosted their
            confidence and strengthened their faith in God, while giving them
            profound lessons in collaboration. Their simplicity of life, their
            witness of joy and dedication to St Paul which was seen by the
            inhabitants of this village earned them the name “Daughters of St
            Paul”. They were no longer unnoticed!
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Row>
              <Col xs={12} md={6}>
                <Card.Img
                  src={image5}
                  className="d-block w-100"
                  style={{ maxHeight: 65 + `vh` }}
                />
              </Col>
              <Col xs={12} md={6} className="divider border-xs-0 align-middle">
                After the experience in Susa, some major developments marked
                their lives. The young women made their religious profession on
                22nd July 1922 hence giving them a certainty of carrying out
                their mission. On 15th March 1929, they were approved by Bishop
                Re, Bishop of Alba. On 15th March 1953, the Congregation was
                erected as an Institute of Pontifical Right and its
                Constitutions received final approval.
              </Col>
            </Row>
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            Beginning in 1926, the Daughters of St Paul ventured out of Italy
            with Blessed James Alberione's prayers and sacrifices, and began
            their expansion beyond Italy into other countries. This expansion
            opened the hearts of the Sisters to the world and gave them a deeper
            sense of belonging.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            The movement out into other countries from 1948 to 1956 gave the
            Congregation a global sense when communities were opened in Japan,
            Mexico, Colombia, Chile, Portugal, Canada, India, Great Britain,
            Australia, and Venezuela… new apostolic initiatives in book
            publications, catechetical magazines, a house for writers and
            central offices for publications were all put into place. New means
            were used to reach people: the cinema, radio and audio cassettes.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Row>
              <Col xs={12} md={6}>
                <Card.Img
                  src={image2}
                  className="d-block w-100"
                  style={{ maxHeight: 65 + `vh` }}
                />
              </Col>
              <Col xs={12} md={6} className="divider align-middle">
                In 1957, the yearning of the Daughters of St Paul to set foot in
                vast Africa was realised. The first country was Congo (DRC) in
                1957. After six years in Congo, the gaze of the sisters was
                turned to Uganda: the land of the Martyrs which welcomed them in
                1964. Three years later in 1967, Mozambique opened its doors for
                the Pauline presence and mission.
              </Col>
            </Row>
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            The story of expansion did not stop here but, following the words of
            Sister Thecla Merlo who said, “Let us dedicate our footsteps to the
            Gospel, may it race ahead and spread,” Tanzania received the
            Daughters in 1970 and Kenya in 1976. The Island of Madagascar, with
            its warm-hearted people, opened its doors to Pauline mission in
            1983.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            In 1994, celebrating the centenary of the birth of Sister Thecla
            Merlo, a missionary project was launched and its fruits were evident
            in the missionary outposts that were born in Zambia, Angola,
            Nigeria, South Africa and the Ivory Coast. Recently the 21st century
            saw Equatorial Guinea and Sudan embracing the Daughters of St Paul.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Row>
              <Col xs={12} md={6}>
                <Card.Img
                  src={image3}
                  className="d-block w-100"
                  style={{ maxHeight: 65 + `vh` }}
                />
              </Col>
              <Col xs={12} md={6} className="divider align-middle">
                The Word of God meets people in over 50 nations through this
                Pauline ministry and yet it cannot be said to have been totally
                accomplished. The gaze of the Sisters is fixed on the world that
                is awaiting the message of Christ and thus the challenge is this
                exaltation of Blessed James Alberione, “Woman is on the move,
                and it's a wonderful thing, a true gift of the Holy Spirit that
                a sister is associated with the priestly zeal. The Daughter of
                St Paul is according to her mission raised to a dignity and
                activity which cannot have further heights.”
              </Col>
            </Row>
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            He continues, “You have reached all continents: as you pass from one
            country to another, fly over mountains, or plough the ocean waves,
            you do not speak of what has been done. Ever onwards, Daughters of
            St Paul, bringing the truth with charity. I think of you, hundreds
            of thousands…on your way towards holiness. You live in the world but
            you are not of the world. Bearers of Christ, living members and
            workers of the Church…Forward! Bring truth in charity.”
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Card.Title
              className="text-maroon my-4 font-header text-left"
              style={{ textTransform: "capitalize" }}
            >
              DAUGHTERS OF ST PAUL IN UGANDA (1964)
            </Card.Title>
            The presence of the Daughters of St Paul in East Africa began in
            Uganda. The history of this presence is tightly interwoven with the
            events that took place in the country in the early 60s. At that time
            the people in Uganda would rather go hungry than not have literature
            to read. The bishops saw a great need to open a book centre where
            inspiring materials for growth in Faith would be found. The Church
            in Uganda prepared the ground, and on 2nd February 1964, the first
            Daughters of St Paul arrived. Arrangements were made for them to
            take over the book centre, and in June 1964 the book centre was
            inaugurated.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            The community of the Daughters of St Paul in Uganda has grown since
            then. Presently the Sisters have the book centre, Paulines Book and
            Media Centre, along Kampala Road. It is from here that they offer
            their witness and service to the people of Uganda. They present book
            exhibitions in schools, institutions, parishes, and any place or
            event that offers an opportunity to bring the Word of God to the
            people. They also have a radio apostolate: they prepare programmes
            that are aired on Radio Maria, an archdiocesan radio station.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            There is a formation house situated in Nakasero, Kyadondo Road. Here
            women who would like to become Daughters of St Paul begin their
            journey of formation into religious life. At the formation house,
            these women already are learning what it means to make use of the
            means of social communications to better understand the mission of
            the life they desire to embrace. They print small booklets and
            produce audio visual materials. During this formation time they go
            out with the Sisters to assist in the propaganda (book exhibitions).
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            Many people within Kampala and in the neighbouring dioceses and
            towns have had access to Pauline books and other materials because
            our Sisters are in this Book and Media Centre. Our Founder, Blessed
            Alberione, always reminded us that our “boundaries are the
            boundaries of the world.” The Sisters were encouraged to go beyond
            the boundaries of Uganda and from there they ventured into Rwanda.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Card.Title
              className="text-maroon my-4 font-header text-left"
              style={{ textTransform: "capitalize" }}
            >
              DAUGHTERS OF ST PAUL IN TANZANIA (1970)
            </Card.Title>
            During the Second Vatican Council, and immediately after, many
            bishops and cardinals visited our Generalate to express their desire
            to have book centres established in their dioceses. In 1970, the
            late Cardinal Rugambwa of Tanzania, while visiting the Generalate,
            personally expressed, “I will not move from here till you have
            signed the agreement to send at least Sisters for my bookshop.” And
            on the 20th September, 1970 the first two Sisters left for Dar es
            Salaam. The Sisters worked tirelessly despite the hard conditions.
            This was the foundation of yet another community in East Africa.
            Over the years, our presence in Tanzania has borne fruit. We have
            vocations from Tanzania. Many people have been blessed by the life
            witness and apostolic service offered to them by the Sisters. A
            recent achievement we thank the Lord for, is the launching of the
            Biblia ya Kiafrika which took place in March 2010.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Card.Title
              className="text-maroon my-4 font-header text-left"
              style={{ textTransform: "capitalize" }}
            >
              DAUGHTERS OF ST PAUL IN KENYA (1976)
            </Card.Title>
            When the Daughters of St Paul arrived in Africa, they were young,
            full of enthusiasm and zeal, and eager to fulfil their mission of
            bringing the Good News of Salvation to the people of Africa by the
            means of social communication. The difficulties in front of them did
            not alarm them. They had the promise of the Lord, Do not be afraid!
            I am with you always, until the end of the age (Cf. Mt 28:10.20).
            The first Sisters were few in number but with extraordinary passion
            to bring the Word of God to the people, with no financial resources
            except their work, no friends to rely on, not much missionary
            experience, poor knowledge of the languages, and plenty of
            day-to-day worries.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            The Sisters in Uganda often came to Nairobi for one reason or
            another, and during each trip they would stop by to greet the then
            Archbishop of Nairobi, Maurice Michael Cardinal Otunga. Being very
            kind and thankful for the Sisters’ work, he would every time and
            unfailingly ask the Sisters, “Do come and run my bookshop in
            Nairobi! You accepted to go to Kampala, and accepted the invitation
            of Cardinal Rugambwa to run his bookshop in Dar es Salaam, so, why
            do you not come to Nairobi?” Although the Sisters were very few,
            there came a time when they could no longer refuse the Cardinal’s
            plea. The General government in 1975 approved the opening of the
            house, and on the 15th February 1976, the diocesan bookshop was
            handed over to the Sisters.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            Currently, the Daughters of St Paul are present in twelve countries
            of the African continent. Still burning with the missionary zeal of
            St Paul the Apostle, they hope, in the near future, to open
            communities in Cameroon, Ghana, Ethiopia, and other countries of
            Africa.
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            The gaze of the Sisters remains fixed on the world that is awaiting
            the message of Christ, and taking seriously the challenge of Blessed
            James Alberione, “Woman is on the move, and it's a wonderful thing,
            a true gift of the Holy Spirit that a Sister is associated with the
            priestly zeal. The Daughter of St Paul is, according to her mission,
            raised to a dignity and activity which cannot have further heights.”
          </Card.Text>

          <Card.Text className="my-4" style={{ lineHeight: 1.5 }}>
            <Card.Title
              className="text-maroon my-4 font-header text-left"
              style={{ textTransform: "capitalize" }}
            >
              DAUGHTERS OF ST PAUL IN SUDAN (2008)
            </Card.Title>
            The 21st century saw Sudan embracing the Daughters of St Paul. This
            community was first opened on 25th January 2008, on the Feast of the
            Conversion of St Paul. The presence of the Daughters of St Paul in
            Sudan was a long-awaited response to a request by the Church of
            Sudan.&nbsp;The people of Sudan were in dire need of spiritual and
            moral support. “It is my prayer and hope that very soon, thanks to
            the help of Divine Providence, the Daughters of St Paul will be able
            to establish a community in Juba and to minister to the people of
            Sudan,” Rt Rev Paolino Lukudu Loro, Archbishop of Juba had
            said.&nbsp;At the moment, the young, vibrant community of the
            Daughters of St Paul lives in a rented house in Juba. The Archbishop
            is also renting to them a Catholic Bookshop situated near the
            Cathedral of Juba.
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
}

export default History;
